import { type BidV2Dto } from "../../../../autogen/bff-api";

export const isBidV2Editable = (
  bid: Pick<BidV2Dto, "isContentEditable">,
): boolean => bid.isContentEditable === true;
